/**
 * FamilyProfile — displays the currently selected family: name, description,
 * and index (e.g. "01 / 10").
 *
 * Keyed by family.id so React remounts the content on family change, which
 * lets the scoped CSS play the short reveal transition on each swap.
 */
export function FamilyProfile({ family }) {
  return (
    <div
      id="family-profile-panel"
      role="tabpanel"
      aria-live="polite"
      data-testid={`family-profile-${family.id}`}
      className="prophets-lore-profile"
    >
      <div className="prophets-lore-profile-head">
        <span className="prophets-lore-profile-tick" aria-hidden="true" />
      </div>

      <div className="prophets-lore-profile-body" key={family.id}>
        <h3 className="p-nav prophets-lore-profile-name" data-testid="family-profile-name">
          {family.name.toUpperCase()}
        </h3>
        <p className="prophets-lore-profile-description" data-testid="family-profile-desc">
          {family.description}
        </p>
      </div>
    </div>
  );
}
